module.exports = "</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/flash-messages/partials/footer.html
// module id = fSfp
// module chunks = 1